import { useFieldArray, useFormContext } from 'react-hook-form';
import { Button, Grid } from '@mui/material';
import type { CountryEntity, SourceOfWealthValue } from '@shared/api';
import { SourceOfWealth } from './sourceOfWealth';

interface SourcesOfWealthProps {
  name: string;
  caption: string;
  countries: CountryEntity[];
  economicActivities: string[];
}

export const SourcesOfWealth = (props: SourcesOfWealthProps) => {
  const { control } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name: props.name,
  });

  const handleAdd = () => append({} as SourceOfWealthValue);

  return (
    <>
      {fields.map((_, idx) => (
        <SourceOfWealth
          key={idx}
          name={props.name}
          index={idx}
          caption={props.caption}
          countries={props.countries}
          economicActivities={props.economicActivities}
          onRemove={idx > 0 ? () => remove(idx) : undefined}
        />
      ))}
      <Grid item xs={12}>
        <Button type='button' onClick={handleAdd}>
          Add additional {props.caption}
        </Button>
      </Grid>
    </>
  );
};
